module.exports = __webpack_public_path__ + "img/kyc-selfy2.421f6614.jpg";